import React from 'react'

import SiteContainer from '../../Containers/SiteContainer/SiteContainer'
import AnimatedBlob from '../../Components/AnimatedBlob/AnimatedBlob'
import BackDrop from '../../Components/BackDrop/BackDrop'
import Content from '../../Components/Content/Content'
import Button from '../../Components/Button/Button'
import Columns from '../../Components/Columns/Columns'
import Divider from '../../Components/Divider/Divider'
import QuoteBlock from '../../Components/QuoteBlock/QuoteBlock'
import Hero from '../../Components/Hero/Hero'
import PhotoCard from '../../Components/PhotoCard/PhotoCard'
import './ContentPage.css'

const ContentPage = () => {
  return (
    <SiteContainer>
      <Hero title="Content Page" modifiers={['fmbm-hero--center']} />
      <Content>
        <h1>
          Some Cool <br />Headline here
        </h1>
        <p>
          Nunc enim odio, semper in convallis quis, consequat nec sapien.
          Vestibulum sit amet iaculis tortor. Maecenas urna lorem, malesuada et
          euismod vel, sagittis in magna. Fusce sed elit nec urna hendrerit
          imperdiet quis eu purus. Curabitur eu mattis turpis, vel accumsan
          neque. Maecenas vel lobortis dolor, quis suscipit dolor.
        </p>
        <p>
          Proin auctor imperdiet mauris eget malesuada. Nam enim lacus,
          vestibulum non pulvinar sit amet, molestie at arcu. Phasellus mattis
          cursus nunc. In ut eros malesuada, ultricies nisi auctor, tristique
          ligula. Nunc est augue, suscipit ut nibh id, gravida placerat orci.
          Sed viverra odio a velit hendrerit, nec gravida velit dictum.
          Vestibulum convallis, lacus quis ullamcorper ullamcorper, lectus ante
          vestibulum purus, nec ultricies ipsum tellus eget augue.
        </p>
      </Content>
      <Divider />
      <Content>
        <Columns number={3}>
          <div>
            <h2>Some Cool Headline</h2>
            <p>
              Let your product shape the technology you use, not the other way
              around." Typically, in the development cycle, a startup founder
              tends to have to dream within the constraints of what their
              developers know. With our team, they are truly no limits.
            </p>
            <Button buttonText="Button" />
          </div>
          <div>
            <h2>Some Cool Headline</h2>
            <p>
              Let your product shape the technology you use, not the other way
              around." Typically, in the development cycle, a startup founder
              tends to have to dream within the constraints of what their
              developers know. With our team, they are truly no limits.
            </p>
            <Button buttonText="Button" />
          </div>
          <div>
            <h2>Some Cool Headline</h2>
            <p>
              Let your product shape the technology you use, not the other way
              around." Typically, in the development cycle, a startup founder
              tends to have to dream within the constraints of what their
              developers know. With our team, they are truly no limits.
            </p>
            <Button buttonText="Button" />
          </div>
        </Columns>
      </Content>
      <Divider />
      <Content>
        <QuoteBlock quoteText="Some Cool Headline here">
          <p>
            Nunc enim odio, semper in convallis quis, consequat nec sapien.
            Vestibulum sit amet iaculis tortor. Maecenas urna lorem, malesuada
            et euismod vel, sagittis in magna. Fusce sed elit nec urna hendrerit
            imperdiet quis eu purus. Curabitur eu mattis turpis, vel accumsan
            neque. Maecenas vel lobortis dolor,{' '}
            <a href="#s">quis suscipit dolor</a>.
          </p>
        </QuoteBlock>
      </Content>
      <Divider />
      <Content>
        <AnimatedBlob hiddenMobile />
        <Columns number={2}>
          <div>
            <BackDrop>
              <img
                alt=""
                src="https://images.unsplash.com/photo-1472841298542-80b08039a5ab?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=d0aff16c91d75e783eff4c6c546b0249&auto=format&fit=crop&w=500&q=80"
              />
            </BackDrop>
          </div>
          <div>
            <h1>Some Cool Headline here</h1>
            <p>
              Nunc enim odio, semper in convallis quis, consequat nec sapien.
              Vestibulum sit amet iaculis tortor. Maecenas urna lorem, malesuada
              et euismod vel, sagittis in magna. Fusce sed elit nec urna
              hendrerit imperdiet quis eu purus. Curabitur eu mattis turpis, vel
              accumsan neque. Maecenas vel lobortis dolor, quis suscipit dolor.
            </p>
          </div>
        </Columns>
      </Content>
      <Divider />
      <Content>
        <Columns number={2} disableReverse>
          <div>
            <h1>Some Cool Headline here</h1>
            <p>
              Nunc enim odio, semper in convallis quis, consequat nec sapien.
              Vestibulum sit amet iaculis tortor. Maecenas urna lorem, malesuada
              et euismod vel, sagittis in magna. Fusce sed elit nec urna
              hendrerit imperdiet quis eu purus. Curabitur eu mattis turpis, vel
              accumsan neque. Maecenas vel lobortis dolor, quis suscipit{' '}
              <a href="#s">dolor</a>.
            </p>
          </div>
          <div>
            <BackDrop color="purple">
              <img
                alt=""
                src="https://images.unsplash.com/photo-1526634967460-8009daabbe9d?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a21239c4a8c9ec18d385c4f92e9f5118&auto=format&fit=crop&w=500&q=80"
              />
            </BackDrop>
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile right />
      </Content>
      <Divider />
      <Content>
        <div className="fmbm-content__center-compact">
          <h1>Some Cool Headline here</h1>
          <p>
            Fusce sed elit nec urna hendrerit imperdiet quis eu purus. Curabitur
            eu mattis turpis, vel accumsan neque. Maecenas vel lobortis dolor
          </p>
        </div>
        <Columns number={2} disableReverse>
          <PhotoCard
            image="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/placeholder-imgs%2Fjoanna-kosinska-439234-unsplash.png?alt=media&token=35a82d61-6c77-4a55-aa5f-aa437ed3496d"
            headline="Some headline"
            subtitle="Interesting text here"
          />
          <PhotoCard
            image="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/placeholder-imgs%2Fmalte-wingen-381988-unsplash.png?alt=media&token=408a235a-188c-4c2a-8ef9-4270af3cd87a"
            headline="Some headline"
            subtitle="Interesting text here"
          />
        </Columns>
        <AnimatedBlob
          hiddenMobile
          modifier="far-left"
          style={{ top: '90px' }}
          color="white"
        />
      </Content>
      <Divider />
    </SiteContainer>
  )
}

export default ContentPage



// WEBPACK FOOTER //
// ./src/Pages/Content/ContentPage.js